export default "__VITE_ASSET__DR1LuB____"